/* eslint-disable func-names, max-len, no-underscore-dangle */
import 'magnific-popup';

if ($('a[href*="youtube.com/watch?"]').length > 0 || $('a[href*="youtube.com/v/"]').length > 0 || $('a[href*="vimeo"]').length > 0) {
  $('a[href*="youtube.com/watch?"]').addClass('popup-youtube');
  $('a[href*="youtube.com/v/"]').addClass('popup-youtube');
  $('a[href*="vimeo"]').addClass('popup-vimeo');

  $('.popup-youtube, .popup-vimeo, .popup-gmaps').magnificPopup({ type: 'iframe', mainClass: 'mfp-fade', removalDelay: 160, preloader: false, fixedContentPos: false });

  $('.image-popup-fit-width').magnificPopup({
    type: 'image',
    closeOnContentClick: true,
    image: {
      verticalFit: false,
    },
  });
}
